import React  from 'react'
import { Outlet } from 'react-router-dom'

const PublicShareRoute = () => {
	return <Outlet/>
}

export default PublicShareRoute